// package: friendemic.api.response
// file: friendemic/api/response/tags.proto
"use strict";

exports.TagFriendly = {
  enumMap: {
		0: "None",
		1: "Spanish",
		2: "French",
		30: "Flagged for Manager",
		40: "Flagged for Dispute",
		50: "Over Limit",
		51: "No Response Needed",
		52: "Internal Approval Needed",
		53: "Awaiting Client Input",
		54: "Serious",
		55: "Mixed Review",
		60: "Profile Turned Off",
		61: "No API Access",
  },
  friendlyMap: {
		"None": 0,
		"Spanish": 1,
		"French": 2,
		"Flagged for Manager": 30,
		"Flagged for Dispute": 40,
		"Over Limit": 50,
		"No Response Needed": 51,
		"Internal Approval Needed": 52,
		"Awaiting Client Input": 53,
		"Serious": 54,
		"Mixed Review": 55,
		"Profile Turned Off": 60,
		"No API Access": 61,
  },
  toFriendly: function(e) {
    const v = this.enumMap[e]
    if (v === undefined) {
      throw new Error(e + ' is not a valid Tag enum option')
    }

    return v
  },
  toEnum: function(v) {
    const e = this.friendlyMap[v]
    if (e === undefined) {
      throw new Error('\'' + v + '\'' + ' is not a valid Tag friendly value')
    }

    return e
  }
}
